import React from 'react';

import { enums, ui } from '../..';
import { mui } from '../../libs';
import * as types from '../../types';

type DsSelectorProps = {
  value: types.benchmark.Benchmark;
  onChange: (_v: types.benchmark.Benchmark) => void;
  isError?: boolean;
  readOnly?: boolean;
};

/**
 * Component that renders an autocomplete selector for benchmark data source indices
 *
 * @param value - The currently selected benchmark value
 * @param onChange - Callback function when selection changes
 * @param isError - Whether to show error state
 *
 * @returns Rendered autocomplete component for benchmark selection
 */
const DsSelector = ({ value, onChange, isError, readOnly = false }: DsSelectorProps) => {
  return (
    <mui.core.Grid item xs={12} md={4}>
      <ui.IndexSelector
        value={value.ds_handle as string}
        setValue={(v) => onChange({ type: enums.BENCHMARK_TYPES_ENUM.DS_INDEX, ds_handle: v as string })}
        errorState={isError}
        disabled={readOnly}
      />
    </mui.core.Grid>
  );
};

export default DsSelector;
